const minMovementFocusAxis = 10; // arbitrary value for what counts as enough movement along the focus axis
const maxMovementOtherAxis = 50; // arbitrary value for what counts as too much movement along the other axis

const touchStartPoint = { x: null, y: null };
const touchEndPoint = { x: null, y: null };

const handleTouchStart = (e) => {
   // save the x,y point for the first touch
   if (e.touches) {
      touchStartPoint.x = e.touches[0].clientX;
      touchStartPoint.y = e.touches[0].clientY;
   }
   // Uncomment to test with mouse movements
   // else if (e.clientX && e.clientY) {
   //    touchStartPoint.x = e.clientX;
   //    touchStartPoint.y = e.clientY;
   // }
};

const handleTouchEnd = (binding) => (e) => {
   // get the x,y point for the last touch recorded on the current target

   if (e.changedTouches) {
      const changedTouchesEnd = e.changedTouches[e.changedTouches.length - 1];
      touchEndPoint.x = changedTouchesEnd.clientX;
      touchEndPoint.y = changedTouchesEnd.clientY;
   }
   // Uncomment to test with mouse movements
   // else {
   //    touchEndPoint.x = e.clientX;
   //    touchEndPoint.y = e.clientY;
   // }
   // console.log(`end: ${touchEndPoint.x} - ${touchEndPoint.y}`);

   // check whether there was a swipe movement (!==0) and in which direction (-1: left, 1: right)
   const swipeMovement = getSwipeMovement(touchStartPoint, touchEndPoint, binding);

   if (swipeMovement !== 0) {
      // In the carousel component we set swipeMovement to be a function which will call 'takeStep' and move the carousel left or right
      // v-swipe="{ swipeMovement: (direction) => takeStep(direction) }"
      binding.value.swipeMovement(swipeMovement);
   }
};

const getSwipeMovement = (startPoint, endPoint, binding) => {
   const focusAxis = binding.value.axis;
   const otherAxis = binding.value.axis === "x" ? "y" : "x";

   // swipe movement, left or right
   if (
      Math.abs(startPoint[focusAxis] - endPoint[focusAxis]) > minMovementFocusAxis &&
      Math.abs(startPoint[otherAxis] - endPoint[otherAxis]) < maxMovementOtherAxis
   ) {
      return startPoint[focusAxis] - endPoint[focusAxis] < 0 ? -1 : 1;
   }
   // there was no swipe movement
   return 0;
};

const vSwipe = {
   // https://vuejs.org/guide/reusability/custom-directives.html
   // Directive hooks are passed these arguments: $el - the element the directive is bound to
   // binding, vNode, prevNode
   created: ($el, binding) => {
      // https://developer.chrome.com/en/docs/lighthouse/best-practices/uses-passive-event-listeners/
      $el.addEventListener("touchstart", handleTouchStart, { passive: true });
      $el.addEventListener("touchend", handleTouchEnd(binding));
      // Uncomment to test with mouse movements
      // $el.addEventListener("mousedown", handleTouchStart);
      // $el.addEventListener("mouseup", handleTouchEnd(binding));
   },
   unmounted: ($el, binding) => {
      $el.removeEventListener("touchstart", handleTouchStart, { passive: true });
      $el.removeEventListener("touchend", handleTouchEnd(binding));
      // Uncomment to test with mouse movements
      // $el.removeEventListener("mousedown", handleTouchStart);
      // $el.removeEventListener("mouseup", handleTouchEnd(binding));
   },
};

export { vSwipe };
